module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开始时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.filters.entimes),
      callback: function($$v) {
        _vm.$set(_vm.filters, "entimes", $$v)
      },
      expression: "filters.entimes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结束时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.filters.entimee),
      callback: function($$v) {
        _vm.$set(_vm.filters, "entimee", $$v)
      },
      expression: "filters.entimee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "h-m-select",
    attrs: {
      "filterable": "",
      "placeholder": "选择站点"
    },
    model: {
      value: (_vm.filters.site),
      callback: function($$v) {
        _vm.$set(_vm.filters, "site", $$v)
      },
      expression: "filters.site"
    }
  }, _vm._l((_vm.service_options), function(item) {
    return _c('el-option', {
      key: item.sites_id,
      attrs: {
        "label": item.sites
      },
      model: {
        value: (item.sites_id),
        callback: function($$v) {
          _vm.$set(item, "sites_id", $$v)
        },
        expression: "item.sites_id"
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.filters.showtime),
      callback: function($$v) {
        _vm.$set(_vm.filters, "showtime", $$v)
      },
      expression: "filters.showtime"
    }
  }, [_vm._v("显示时间")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.filters.showsite),
      callback: function($$v) {
        _vm.$set(_vm.filters, "showsite", $$v)
      },
      expression: "filters.showsite"
    }
  }, [_vm._v("显示Site")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getLists
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', [(_vm.filters.toXls) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downXls
    }
  }, [_vm._v("生成下载XLS")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "data": _vm.datalist,
      "border": "",
      "stripe": "",
      "highlight-current-row": "",
      "height": "500",
      "summary-method": _vm.formatXxfUp,
      "show-summary": ""
    }
  }, [(_vm.filters.noShowColTable) ? _c('el-table-column', {
    attrs: {
      "label": "----",
      "min-width": "30"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filters.showtimeTable) ? _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "Daily",
      "min-width": "60"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.filters.showsiteTable) ? _c('el-table-column', {
    attrs: {
      "prop": "alis_index",
      "label": "site",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(scope.row.alis_index + "--" + scope.row.site) + "\n\t\t\t\t\t")])]
      }
    }], null, false, 2569334308)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "requests",
      "label": "请求数",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pp_requests",
      "label": "填充数",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fill_rate",
      "label": "覆盖率(%)",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imp",
      "label": "展示",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click",
      "label": "点击",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ctr",
      "label": "CTR(%)",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publisher_cpc",
      "label": "CPC",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publisher_cpm",
      "label": "ECPM",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "net_revenue",
      "label": "分成前收益",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publisher_revenue",
      "label": "分成后收益",
      "min-width": "80"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-50f46e1c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/adx/report.vue
// module id = 650
// module chunks = 1